import { render, staticRenderFns } from "./AddNews.vue?vue&type=template&id=36538c56"
import script from "./AddNews.vue?vue&type=script&lang=js"
export * from "./AddNews.vue?vue&type=script&lang=js"
import style0 from "./AddNews.vue?vue&type=style&index=0&id=36538c56&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports